"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _wrapper = require("@uniqore/wrapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Container = (0, _styles.styled)('div')({
  textAlign: 'center',
  borderTop: '1px solid rgba(0, 44, 56, 0.12)',
  padding: '3px 0px 8px 0px',
  color: 'rgba(0, 44, 56, 0.38)',
  background: 'white'
});

const WhiteLabel = ({
  style,
  className
}) => {
  return _react.default.createElement("div", {
    style: style,
    className: className
  }, _react.default.createElement(Container, null, _react.default.createElement(_wrapper.UqTypography, {
    component: "span",
    sx: {
      margin: 0,
      fontSize: 12
    }
  }, "Made with", ' '), _react.default.createElement(_wrapper.UqTypography, {
    sx: {
      color: 'rgba(0, 44, 56, 0.60)',
      fontWeight: 700,
      textDecoration: 'none',
      fontSize: 12,
      margin: 0
    },
    component: "a",
    href: "https://uniqore.com/welcome",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Uniqore\u2122")));
};

var _default = WhiteLabel;
exports.default = _default;